(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["game-slide-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('game-slide-banner')) {
    class GameSlideBanner extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.track = this.querySelector('.game-banner__track');
        this.viewport = this.querySelector('.game-banner__viewport');
        this.slides = Array.from(this.track.children);
        this.count = this.slides.length;
        if (!this.count) return;
        this.index = 0;
        this.position = this.count > 1 ? 1 : 0;
        this.speed = Number(this.dataset.speed) || 500;
        this.delay = Number(this.dataset.delay) || 6500;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.reduced.matches;
        this.hovered = false;
        this.focused = false;
        this.editing = false;
        this.busy = false;
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.pauseButton = this.querySelector('[data-pause]');
        if (this.count > 1) {
          const first = this.slides[0].cloneNode(true);
          const last = this.slides[this.count - 1].cloneNode(true);
          [first, last].forEach(clone => {
            clone.dataset.clone = 'true';
            clone.inert = true;
            clone.setAttribute('aria-hidden', 'true');
            clone.removeAttribute('data-shopify-editor-block');
            clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
          });
          this.track.prepend(last);
          this.track.append(first);
        }
        this.dataset.ready = 'true';
        this.move(false);
        this.update();
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(-1), { signal });
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(1), { signal });
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.select(index), { signal }));
        this.pauseButton?.addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); this.schedule(); }, { signal });
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, { signal });
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, { signal });
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, { signal });
        this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, { signal });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });
        this.reduced.addEventListener('change', () => { if (this.reduced.matches) this.paused = true; this.updatePause(); this.schedule(); }, { signal });
        this.track.addEventListener('transitionend', event => { if (event.target === this.track && event.propertyName === 'transform') this.finish(); }, { signal });
        this.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.go(event.key === 'ArrowRight' ? 1 : -1); }
        }, { signal });
        this.viewport.addEventListener('pointerdown', event => {
          this.swipe = event.isPrimary && event.pointerType !== 'mouse' ? { x: event.clientX, y: event.clientY, id: event.pointerId } : null;
          this.suppressClick = false;
        }, { signal });
        this.viewport.addEventListener('pointerup', event => {
          if (!this.swipe || event.pointerId !== this.swipe.id) return;
          const x = event.clientX - this.swipe.x;
          const y = event.clientY - this.swipe.y;
          this.swipe = null;
          if (Math.abs(x) > 50 && Math.abs(x) > Math.abs(y) * 1.5) { this.suppressClick = true; this.go(x < 0 ? 1 : -1); }
        }, { signal });
        this.viewport.addEventListener('pointercancel', () => { this.swipe = null; }, { signal });
        this.viewport.addEventListener('click', event => { if (this.suppressClick) { event.preventDefault(); event.stopPropagation(); this.suppressClick = false; } }, { signal, capture: true });
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.editing = true;
          this.finish();
          this.select(index, false);
          this.schedule();
        }, { signal });
        document.addEventListener('shopify:block:deselect', event => {
          if (!this.slides.some(slide => slide.dataset.blockId === event.detail.blockId)) return;
          this.editing = false;
          this.schedule();
        }, { signal });
        this.updatePause();
        this.schedule();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        clearTimeout(this.fallback);
        this.abort?.abort();
        this.abort = null;
        this.querySelectorAll('[data-clone]').forEach(clone => clone.remove());
        delete this.dataset.ready;
      }
      move(animate) {
        const duration = animate && !this.reduced.matches ? this.speed : 0;
        this.track.style.transition = duration ? `transform ${duration}ms ease-in-out` : 'none';
        this.track.style.transform = `translateX(${-this.position * 100}%)`;
        return duration;
      }
      go(direction) {
        if (this.busy || this.count < 2) return;
        this.navigate((this.index + direction + this.count) % this.count, this.position + direction, true);
      }
      select(index, animate = true) {
        if (this.busy || index === this.index || this.count < 2) return;
        this.navigate(index, index + 1, animate);
      }
      navigate(index, position, animate) {
        clearTimeout(this.timer);
        this.index = index;
        this.position = position;
        this.busy = true;
        const duration = this.move(animate);
        this.update();
        if (duration) this.fallback = setTimeout(() => this.finish(), duration + 100);
        else this.finish();
      }
      finish() {
        clearTimeout(this.fallback);
        if (this.count > 1 && this.position === 0) this.position = this.count;
        if (this.count > 1 && this.position === this.count + 1) this.position = 1;
        this.move(false);
        this.track.getBoundingClientRect();
        this.busy = false;
        this.schedule();
      }
      update() {
        this.slides.forEach((slide, index) => { slide.inert = index !== this.index; slide.setAttribute('aria-hidden', String(index !== this.index)); });
        this.dots.forEach((dot, index) => { if (index === this.index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
        const status = this.querySelector('.game-banner__status');
        if (status && (this.focused || this.paused)) status.textContent = this.slides[this.index].getAttribute('aria-label');
      }
      updatePause() {
        if (!this.pauseButton) return;
        this.pauseButton.setAttribute('aria-pressed', String(this.paused));
        this.pauseButton.setAttribute('aria-label', this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
        this.pauseButton.querySelector('[data-play-icon]').hidden = !this.paused;
        this.pauseButton.querySelector('[data-pause-icon]').hidden = this.paused;
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.dataset.autoplay !== 'true' || this.count < 2 || this.busy || this.paused || this.hovered || this.focused || this.editing || document.hidden) return;
        this.timer = setTimeout(() => this.go(1), this.delay);
      }
    }
    customElements.define('game-slide-banner', GameSlideBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
